import type { ApiClient } from './runtime/apiRuntime';
import { apiMutationOptions, BaseApiMutationOptions } from './apiMutationOptions';
import { apiQueryOptions, BaseApiQueryOptions } from './apiQueryOptions';

export const TranslationApi = {
    get: (language: string, options?: BaseApiQueryOptions) =>
        apiQueryOptions(['translation', 'get', language], (api) => api.translation.get(language), options),
    update: (options?: BaseApiMutationOptions<ApiClient['translation']['update']>) => apiMutationOptions((api) => api.translation.update, options)
};
